<template>
    <b-modal title="Form Sumber Kas Penjualan" id="kas-modal" no-close-on-backdrop no-close-on-esc>
        <b-form-group label="Nominal">
            <h4>
                <i class="text-success"><strong>
                    Rp {{ formatRupiah(totalPenjualan) }}
                </strong></i>
            </h4>
        </b-form-group>
        <b-form-group label="Pilih Akun" class="mb-2">
            <v-select label="text" :options="akunOptions" v-model="akun" class="mb-1"></v-select>
        </b-form-group>
        <b-form-group label="Pilih Kas" class="mb-2">
            <v-select label="text" :options="kasOptions" v-model="form.id_kas" :reduce="option => option.value"></v-select>
        </b-form-group>

        <template #modal-footer>
            <b-button variant="primary" @click.prevent="submit" :disabled="!isValidForm">Simpan</b-button>
        </template>
    </b-modal>
</template>
<script>
import {BModal, BFormGroup, BButton} from 'bootstrap-vue'
import vSelect from 'vue-select'
export default {
    components: {
        BModal, BFormGroup, BButton, vSelect
    },
    data: () => ({
        akun: null,
        form: {
            id: null,
            aktor: 'finance',
            id_akun: null,
            status: 1,
            id_kas: null
        }
    }),
    computed: {
        totalPenjualan(){
            return this.$store.state.asset.currentTotalPenjualan
        },
        isValidForm() {

            if(!this.akun ||!this.form.id_kas) {
                return false
            }

            return true
        },
        isKas() {
            if(this.akun && this.akun.kategori && this.akun.kategori.kategori == 'Kas & Bank') {
                return true
            }

            return false
        },
        kasOptions() {
            return JSON.parse( JSON.stringify(this.$store.state.asset.kasOptions) )
        },
        akunOptions() {
            return JSON.parse( JSON.stringify(this.$store.state.asset.akunOptions) )
        }
    },
    methods: {
        submit() {
            if(!this.isValidForm) {
                this.displayError({
                    message: 'Harap lengkapi form pemilihan sumber kas!'
                })
                return false
            }

            this.form.id_akun = this.akun.value
            this.form.id = this.$route.params.id
            this.$emit('submitKas', this.form)
        }
    }
}
</script>